import styled, { css } from 'styled-components';
import { animated } from 'react-spring';

type ContainerProps = {
  type?: 'success' | 'error' | 'info';
  hasdescription: boolean;
}

const toastTypeVariations = {
  info: css`
    background: #ebf8ff;
    color: #3172b7;
  `,
  success: css`
    background: #e6fffa;
    color: #2e656a;
  `,
  error: css`
    background: #fddede;
    color: #c53030;
  `,
};

export const Container = styled(animated.div)<ContainerProps>`
  width: 360px;

  position: relative;
  padding: 10px 30px 16px 16px;
  border-radius: 10px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);

  display: flex;

  & + div {
    margin-top: 8px;
  }

  ${props => toastTypeVariations[props.type || 'info']}

  > svg {
    margin: 4px 12px 0 0;
  }

  div {
    flex: 1;

    p {
      margin-top: 4px;
      font-size: 14px;
      opacity: 0.8px;
      line-height: 20px;
    }
  }

  button {
    position: absolute;
    right: 6px;
    top: 6px;
    opacity: 0.6;
    border: 0;
    background: transparent;
    color: inherit;
  }

  ${props =>
    !props.hasdescription &&
    css`
      align-items: center;

      svg {
        margin-top: 0;
      }
    `}

  @media (max-width: 600px) {
    width: 340px;
    padding: 10px 15px 13px 13px;

    div {
      p {
        font-size: 12px;
      }
    }
  }

  @media (max-width: 400px) {
    width: 310px;
    padding: 10px 15px 13px 13px;

    div {
      p {
        font-size: 12px;
      }
    }
  }
`;
